import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import BookingButton from "./utilities/BookingButton";

// Import des images (ajustez les chemins selon votre structure)
import image1 from "../assets/images/1.jpg";
import image2 from "../assets/images/2.jpg";
import image3 from "../assets/images/3.jpg";
import image4 from "../assets/images/4.jpg";

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [image1, image2, image3, image4];
  const slides2 = [
    "https://api.institutbarberlys.com/slides/1.jpg",
    "https://api.institutbarberlys.com/slides/2.jpg",
    "https://api.institutbarberlys.com/slides/3.jpg",
    "https://api.institutbarberlys.com/slides/4.jpg",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change d'image toutes les 5 secondes

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section className="w-full overflow-hidden z-0 relative bg-primary min-h-screen flex flex-col items-center justify-center px-4">
      {/* Carrousel d'arrière-plan */}
      <div className="absolute inset-0 z-0">
        {/* Afficher seulement l'image active et la suivante pour préchargement */}
        {slides2.map((slide, index) => {
          // Afficher seulement l'image active et la prochaine
          const isActive = index === currentSlide;
          const isNext = index === (currentSlide + 1) % slides.length;

          if (!isActive && !isNext) return null;

          return (
            <div
              key={index}
              className={`absolute inset-0 transition-transform duration-1000 ease-in-out ${
                isActive
                  ? "translate-x-0"
                  : index < currentSlide
                  ? "-translate-x-full"
                  : "translate-x-full"
              }`}
            >
              <img
                src={slide}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
                loading={isActive ? "eager" : "lazy"}
              />
            </div>
          );
        })}
        <div className="absolute inset-0 bg-black/80"></div>
      </div>

      {/* Decorative blurred blobs - maintenus mais avec z-index ajusté */}
      <div className="absolute top-[20vh] left-0 w-80 h-80 bg-secondary-100/20 rounded-full blur-3xl z-0" />
      <div className="absolute top-[20vh] right-0 w-[18rem] h-[28rem] bg-secondary-500/20 rounded-full blur-3xl z-0" />

      <div className="flex flex-col items-center mb-6 z-10 relative">
        <div className="text-center mt-10 max-w-3xl">
          {/* <span className="font-poppins font-medium text-[15px] text-[#444] bg-secondary-50 px-2 py-1">
            Salon de beauté & bien-être
          </span> */}

          <h1 className="font-poppins font-semibold text-[32px] md:text-[48px] mt-4 leading-snug text-white">
            Sublimez votre{" "}
            <span className="bg-gradient-to-r from-white to-secondary-200 bg-clip-text text-transparent">
              style
            </span>{" "}
            et votre{" "}
            <span className="bg-gradient-to-r from-white via-secondary-300 to-secondary-100 bg-clip-text text-transparent">
              bien-être
            </span>
          </h1>

          <p className="mt-4 font-nunito text-[14px] md:text-[16px] text-gray-200">
            Un concept unique alliant coiffure, soins esthétiques et détente
            dans un cadre élégant et apaisant.
          </p>

          <div className="mt-6 flex flex-wrap justify-center gap-4">
            <BookingButton label="Prendre rendez-vous" />
            <Link
              to="/services"
              className="border border-gray-300 font-nunito font-semibold text-[14px] text-white px-6 py-2 hover:border-white hover:bg-white/10 transition duration-300"
            >
              Découvrir nos services
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;